import './sentry.config';
import './i18n.config';

import App                from './App';
import theme              from '@/theme.ts';
import { BrowserRouter }  from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { createRoot }     from 'react-dom/client';
import { Toaster }        from '@/components/ui/toaster';

createRoot(document.getElementById('root')!).render(
	<ChakraProvider value={theme}>
		<BrowserRouter
			future={{
				v7_startTransition: true,
				v7_relativeSplatPath: true,
			}}
		>
			<App />
		</BrowserRouter>


		<Toaster />
	</ChakraProvider>,
);